import { DataGridPremium, GridColDef, itIT } from '@mui/x-data-grid-premium';
import TenantPage from 'components/common/TenantPage';
import { MovementVersionsColumns } from 'components/common/enhanced/common-headers/version-movement';
import { IVersion } from 'interfaces';
import { logService } from 'services/api/LogService';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MovementVersionDialog from '../components/MovementVersionDialog';

export const MovementVersionsPage = () => {
  const translationPrefix = 'pages.versions.movement';
  const [selectedVersion, setSelectedVersion] = useState<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [versions, setVersions] = useState<IVersion[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const { t } = useTranslation();
  useEffect(() => {
    setLoading(true);
    const offset = page * pageSize;
    logService
      .getAllPaginated(pageSize, offset, { model_name: 'movement' })
      .then((response) => {
        setVersions(response.results);
        setRowCount(Number(response.count ?? response.results?.length ?? 0));
      })
      .finally(() => setLoading(false));
  }, [page, pageSize]);

  const handleOpenDialog = (id: string) => {
    const version = versions.find((v) => v.id === Number(id));
    setSelectedVersion(version);
    setDialogOpen(true);
  };

  const columns: GridColDef[] = MovementVersionsColumns(handleOpenDialog);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <div style={{ height: 1000, width: '100%' }}>
        <DataGridPremium
          density="compact"
          rows={versions}
          loading={loading}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          sx={{ border: 'none', height: '75vh' }}
          disableSelectionOnClick
          pagination
          paginationMode="server"
          rowCount={rowCount}
          page={page}
          pageSize={pageSize}
          onPageChange={(nextPage) => setPage(nextPage)}
          onPageSizeChange={(nextSize) => {
            setPage(0);
            setPageSize(nextSize);
          }}
          columns={columns}
          rowsPerPageOptions={[10, 20, 50]}
        />
      </div>
      {selectedVersion && (
        <MovementVersionDialog
          open={dialogOpen}
          onClose={() => {
            setSelectedVersion(null);
            setDialogOpen(false);
          }}
          versionId={selectedVersion?.id}
        />
      )}
    </TenantPage>
  );
};

export default MovementVersionsPage;
